import React, { Component } from "react";

class TokenRefresh extends Component {
  render() {
    return (
      <>
        <div>refresh token</div>
      </>
    );
  }
}

export default TokenRefresh;